/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-b011b919.mjs';
import { defineComponent, toRefs, ref, computed, nextTick, onMounted, watch, createVNode, mergeProps } from 'vue';
import { d as dayjs } from '../../_chunks/dep-99a0abba.mjs';
import { c as customParseFormat } from '../../_chunks/dep-576ed755.mjs';
import { DEFAULT_FORMAT, DEFAULT_STEPS } from '../../_common/js/time-picker/const.mjs';
import { panelProps } from './props.mjs';
import SinglePanel from './single-panel.mjs';
import TButton from '../../button/button.mjs';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { useConfig } from '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-ae1abe1d.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-63c5b255.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-8d19eb1a.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-06221fe2.mjs';
import '../../_chunks/dep-a6022780.mjs';
import '../../_chunks/dep-6dd0e2df.mjs';
import '../props.mjs';
import '../../_chunks/dep-fc63c737.mjs';
import '../../_chunks/dep-2a2a0e63.mjs';
import '../../_chunks/dep-83588d06.mjs';
import '../../_chunks/dep-9b57842b.mjs';
import '../../_chunks/dep-cc371884.mjs';
import '../../_chunks/dep-3e3494dc.mjs';
import '../../_chunks/dep-ebe8bc2f.mjs';
import '../../_chunks/dep-750294df.mjs';
import '../../_chunks/dep-e05e20e6.mjs';
import '../../_chunks/dep-94585de3.mjs';
import '../../_chunks/dep-b9567f6a.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-f3e3393e.mjs';
import '../../_chunks/dep-0fa7026c.mjs';
import '../../_chunks/dep-414fd915.mjs';
import '../../_common/js/time-picker/utils.mjs';
import '../../_chunks/dep-56ceb7ce.mjs';
import '../../loading/index.mjs';
import '../../loading/directive.mjs';
import '../../loading/plugin.mjs';
import '../../loading/loading.mjs';
import '../../loading/icon/gradient.mjs';
import '../../_common/js/loading/circle-adapter.mjs';
import '../../_common/js/utils/set-style.mjs';
import '../../_common/js/utils/helper.mjs';
import '../../_chunks/dep-c3626417.mjs';
import '../../_chunks/dep-7f2f03b4.mjs';
import '../../_chunks/dep-e00db566.mjs';
import '../../_chunks/dep-fdde96c5.mjs';
import '../../_chunks/dep-961339ce.mjs';
import '../../utils/dom.mjs';
import '../../utils/easing.mjs';
import '../../utils/render-tnode.mjs';
import '../../_chunks/dep-ff1c0573.mjs';
import '../../_chunks/dep-42be3824.mjs';
import '../../_chunks/dep-a11a63ea.mjs';
import '../../_chunks/dep-ad1accf9.mjs';
import '../../_chunks/dep-a255de71.mjs';
import '../../_chunks/dep-ebfafd52.mjs';
import '../../_chunks/dep-f50ac97c.mjs';
import '../../_chunks/dep-d7053a2c.mjs';
import '../../_chunks/dep-31dc9d09.mjs';
import '../../_chunks/dep-b9d74a58.mjs';
import '../../loading/props.mjs';
import '../../hooks/useTeleport.mjs';
import '../../_chunks/dep-adebe2ce.mjs';
import '../../_chunks/dep-bd3d75f1.mjs';
import '../../_chunks/dep-2b8d75e2.mjs';
import '../../_chunks/dep-8f44163a.mjs';
import '../../_chunks/dep-1f0070bb.mjs';
import '../../_chunks/dep-9d0d32fd.mjs';
import '../../_chunks/dep-67dfe9c7.mjs';
import '../../_chunks/dep-a0bd2e3a.mjs';
import '../../_chunks/dep-91208ac3.mjs';
import '../../_chunks/dep-1041f7d7.mjs';
import '../../_chunks/dep-b32fb318.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-9d5ee0e1.mjs';
import '../../config-provider/type.mjs';
import '../../utils/withInstall.mjs';
import './style/css.mjs';
import '../../loading/type.mjs';
import '../../button/props.mjs';
import '../../hooks/useRipple.mjs';
import '../../hooks/useKeepAnimation.mjs';
import '../../utils/set-style.mjs';
import '../../form/hooks.mjs';
import '../../hooks/tnode.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
dayjs.extend(customParseFormat);
var _TimePickerPanel = defineComponent({
  name: "TTimePickerPanel",
  props: _objectSpread(_objectSpread({}, panelProps()), {}, {
    isFooterDisplay: Boolean,
    handleConfirmClick: Function,
    onChange: Function
  }),
  setup: function setup(props) {
    var panelClassName = usePrefixClass("time-picker__panel");
    var _toRefs = toRefs(props),
      steps = _toRefs.steps,
      isFooterDisplay = _toRefs.isFooterDisplay,
      isShowPanel = _toRefs.isShowPanel;
    var triggerScroll = ref(false);
    var panelRef = ref();
    var _useConfig = useConfig("timePicker"),
      globalConfig = _useConfig.globalConfig;
    var showNowTimeBtn = computed(function () {
      return !!steps.value.filter(function (v) {
        return v > 1;
      }).length;
    });
    var defaultValue = computed(function () {
      var isStepsSet = showNowTimeBtn.value;
      if (props.value) {
        return dayjs(props.value, props.format);
      }
      if (isStepsSet) {
        return dayjs().hour(0).minute(0).second(0);
      }
      return dayjs();
    });
    var panelColUpdate = function panelColUpdate() {
      nextTick(function () {
        triggerScroll.value = true;
      });
    };
    var resetTriggerScroll = function resetTriggerScroll() {
      triggerScroll.value = false;
    };
    onMounted(function () {
      panelColUpdate();
    });
    watch(function () {
      return isShowPanel.value;
    }, function () {
      panelColUpdate();
    });
    return function () {
      return createVNode("div", {
        "class": panelClassName.value
      }, [createVNode("div", {
        "class": "".concat(panelClassName.value, "-section-body")
      }, [createVNode(SinglePanel, mergeProps(props, {
        "ref": panelRef,
        "format": props.format || DEFAULT_FORMAT,
        "steps": props.steps || DEFAULT_STEPS,
        "value": props.value,
        "triggerScroll": triggerScroll.value,
        "onChange": props.onChange,
        "resetTriggerScroll": resetTriggerScroll,
        "isShowPanel": props.isShowPanel
      }), null)]), isFooterDisplay.value ? createVNode("div", {
        "class": "".concat(panelClassName.value, "-section-footer")
      }, [createVNode(TButton, {
        "theme": "primary",
        "variant": "base",
        "onClick": function onClick() {
          return props.handleConfirmClick(defaultValue.value);
        },
        "size": "small"
      }, {
        "default": function _default() {
          return [globalConfig.value.confirm];
        }
      }), !showNowTimeBtn.value ? createVNode(TButton, {
        "theme": "primary",
        "variant": "text",
        "size": "small",
        "onClick": function onClick() {
          return props.onChange(dayjs().format(props.format));
        }
      }, {
        "default": function _default() {
          return [globalConfig.value.now];
        }
      }) : null]) : null]);
    };
  }
});

export { _TimePickerPanel as default };
//# sourceMappingURL=time-picker-panel.mjs.map
